import React from 'react';
import TopMenu from '@src/business-components/top-menu';
import MapStore from './store';
import wrapStore from '@src/utils/wrap-store';
import styles from './index.less';
import Page from '@src/components/page';
import cx from 'classnames';
import Link from '@src/components/link';
import BaseSwiper from '@src/components/swiper/base-swiper';
import CommonFooter from '@src/business-components/common-footer';
import redirect from '@src/utils/redirect-if-mobile-accress';
// 移动端页面，如果是PC端访问，跳转到PC端页面
//redirect.redirectIfPc();

const Map = ({ store }) => {
  store.use();

  //console.log(store.slidesData, 'slidesData');
  const renderIndicator = () => {
    if (store?.slidesData) {
      return (
        <div className={styles.indicator}>
          {store.slidesData?.map((item, index) => {
            return (
              <div key={index} className={cx(styles.indicatorItem, index === store.swiperStore.activeIndex && styles.indicatorActive)}>
                {/* <div className={cx(styles.progress1)} /> */}
                {/* <div className={cx(styles.progress2)} /> */}
              </div>
            );
          })}
        </div>
      );
    }
  };

  const renderSwiper = () => {
    if (store?.slidesData) {
      return (
        <div className={styles.swiper}>
          <BaseSwiper store={store.swiperStore}>
            {store.slidesData?.map((item, index) => {
              return (
                <div className={styles.swiper_silde} key={index}>
                  <React.Fragment key={index}>
                    <div className={cx(styles.img, store.tabIndex === index && styles.imgActive)} style={{ backgroundImage: `url(${item?.map_img})` }} />
                    <div className={cx(styles.info, store.tabIndex === index && styles.infoActive)}>
                      {/* 标题 */}
                      <div className={styles.title}>{item.title_name}</div>
                      {/* 英文标题 */}
                      {/* <div className={styles.enTitle}>{item.enTitle_name}</div> */}
                      {/* 描述 */}
                      <div className={styles.desc}>
                        <div className={styles.desc_icon1} />
                        <div className={styles.desc_icon2} />
                        {item.desc}
                      </div>
                    </div>
                  </React.Fragment>

                  {/* <div className={styles.swiper_tab}>
                    {item.contentList?.map((tab, index) => (
                      <div key={index} className={cx(styles.tabItem, index === store.tabIndex && styles.tabActive)} onClick={() => store.changeTab(index)}>
                        <div className={styles.tabInner} style={{ backgroundImage: `url(${tab.tab_img})` }} />
                      </div>
                    ))}
                  </div> */}
                </div>
              );
            })}
          </BaseSwiper>
        </div>
      );
    }
  };

  return (
    <Page className={styles.root}>
      <TopMenu />
      {/* 轮播指示器 */}
      <div className={styles.tabBox}>
        {renderIndicator()}
        {/*  页角+切换 */}
        <div className={styles.pageNumBox}>
          <Link className={styles.btnPrev} onClick={store.swiperStore.goPrev} />
          <div className={styles.pageNum}>
            <div className={styles.page_map}>MAP</div>
            <div className={styles.pageNum_item}>
              <span className={styles.current_pageNum}>0{store.swiperStore.activeIndex + 1}</span>/
              <span>0{store.slidesData?.length}</span>
            </div>
          </div>
          <Link className={styles.btnNext} onClick={store.swiperStore.goNext} />
        </div>
      </div>
      {/* 轮播 */}
      {renderSwiper()}
      {/* 底栏 */}
      <div className={styles.footerBox}>
        <CommonFooter store={store.CommonFooterStore} />
      </div>
    </Page>
  );
};

export default wrapStore(Map, MapStore);
